@if (data()) {
  <section class="flux-list" [class.flux-list--compact]="compact()" data-testid="chat-flux-list">
    @if (title()) {
      <header class="flux-list__header">
        <span class="flux-list__title text-neutrals-text-default">{{ title() }}</span>
        <palantir-badge theme="primary-soft">{{ count() }}</palantir-badge>
      </header>
    }

    <ul class="flux-list__items">
      @for (row of rows(); track row.id) {
        <li data-testid="chat-flux-list-item">
          @if (row.href) {
            <a
              class="flux-list__card flux-list__card--link"
              [href]="row.href"
              target="_blank"
              rel="noopener noreferrer"
              [attr.aria-label]="'Abrir ' + row.title + ' em nova aba'"
              data-testid="chat-flux-list-item-link"
            >
              <ng-container
                [ngTemplateOutlet]="rowBody"
                [ngTemplateOutletContext]="{ $implicit: row }"
              />
            </a>
          } @else {
            <div class="flux-list__card">
              <ng-container
                [ngTemplateOutlet]="rowBody"
                [ngTemplateOutletContext]="{ $implicit: row }"
              />
            </div>
          }
        </li>
      }
    </ul>

    @if (footer(); as footerText) {
      <footer class="flux-list__footer text-neutrals-text-secondary">{{ footerText }}</footer>
    }
  </section>
} @else {
  <p class="flux-list__fallback text-neutrals-text-default" data-testid="chat-flux-list-fallback">
    {{ component().fallbackText }}
  </p>
}

<!-- Conteúdo da linha, compartilhado entre a variante link (<a>) e a estática (<div>). -->
<ng-template #rowBody let-row>
  @if (row.avatars.length) {
    <palantir-avatar-group class="flux-list__avatars">
      @for (avatar of row.avatars; track avatar.name) {
        <palantir-avatar
          size="2xs"
          [title]="avatar.name"
          [style.--flux-avatar-bg]="avatar.color || null"
          >{{ avatar.name }}</palantir-avatar
        >
      }
    </palantir-avatar-group>
  }

  <div class="flux-list__text">
    <span class="flux-list__item-title text-neutrals-text-default">{{ row.title }}</span>
    @if (showSubtitle() && row.subtitle) {
      <span class="flux-list__item-subtitle text-neutrals-text-secondary">
        <span class="flux-list__subtitle-text">{{ row.subtitle }}</span>
      </span>
    }
  </div>

  @if (row.badges.length) {
    <div class="flux-list__badges">
      @for (badge of row.badges; track badge.label) {
        <palantir-tag [color]="tagColor(badge.theme)" prefix="circle-filled" size="xs">{{
          badge.label
        }}</palantir-tag>
      }
    </div>
  }

  <palantir-icon class="flux-list__chevron text-neutrals-text-faint" name="chevron-right-outline" />
</ng-template>
